import React, { FC, useCallback } from "react";
import { RadioGroup, RadioGroupOption } from "Shared/components/radio-group";
import { DataTableItem } from "../types";
import { getRowId } from "../utils";

type DataTableRadioGroupProps = {
    item: DataTableItem;
    onRadioChange: (item: DataTableItem) => void;
};

export const DataTableRadioGroup: FC<DataTableRadioGroupProps> = ({
    item,
    onRadioChange,
}) => {
    const handleRadioGroupChanged = useCallback(
        (_: RadioGroupOption["value"]) => onRadioChange(item),
        [item],
    );

    const rowId = getRowId(item);

    return (
        <RadioGroup
            onChange={handleRadioGroupChanged}
            options={[
                {
                    label: "",
                    value: rowId,
                },
            ]}
            selectedOption={item.isPrimary ? rowId : ""}
            small
        />
    );
};
